import { render } from "./SidebarBrand.vue?vue&type=template&id=2a9fe16b"
import script from "./SidebarBrand.vue?vue&type=script&lang=js"
export * from "./SidebarBrand.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__